enum ItemType {
    ARTICLE_CONTENT =1,
    OUTREACH_CONTENT=3,
    SOCIAL_MEDIA_CONTENT,
    CONTENT_RESEARCH,
    TIME_PERIOD,
    ADJUSTMENTS,
    TLDR_CONTENT,
    REPUBLISH,
    VIDEO_CONTENT,
    LEAD_BONUS_PERIOD,
    ARTICLE_GROUP,
    PURCHASES,
    TRAVEL_MEALS_ENTERTAINMENT,
    DIRECT_DEAL,
}

export default ItemType


// WEBPACK FOOTER //
// ./js/utils/ItemType.ts